var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('dyt-input',_vm._g(_vm._b({staticClass:"dyt-textarea",on:{"on-focus":_vm.focusFun},model:{value:(_vm.textareaVal),callback:function ($$v) {_vm.textareaVal=$$v},expression:"textareaVal"}},'dyt-input',_vm.selectConfig,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }